var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from "react";
var SvgAzure = function SvgAzure(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_657_25587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6933 35.1732L31.8133 48.8799L53.3067 35.1199L56 38.2665L31.8133 53.8399L8 38.2665L10.6933 35.1732Z",
    fill: "#50E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2935 33.4135L31.8135 10.1602L51.7335 33.4402L31.8135 46.0268L12.2935 33.4135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8135 10.1602V46.0268L12.2935 33.4135L31.8135 10.1602Z",
    fill: "#50E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8135 10.1602V46.0268L51.7335 33.4402L31.8135 10.1602Z",
    fill: "url(#paint0_linear_657_25587)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8135 28.6929L51.7335 33.4395L31.8135 46.0262V28.6929Z",
    fill: "#53B1E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8135 46.0262L12.2935 33.4129L31.8135 28.6929V46.0262Z",
    fill: "#9CEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8135 53.8399L56.0001 38.2665L53.3068 35.1199L31.8135 48.8799V53.8399Z",
    fill: "url(#paint1_linear_657_25587)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_657_25587",
    x1: 43.3335,
    y1: 42.7202,
    x2: 30.9868,
    y2: 19.3335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1988D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#54AEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_657_25587",
    x1: 38.0268,
    y1: 35.9199,
    x2: 46.5601,
    y2: 50.6399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#54AEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#4FABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#41A2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#2A93E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#1988D9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_657_25587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(8 8)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAzure, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/azure.cb418e3759fba954f2c49c886c5e6f66.svg";
export { ForwardRef as ReactComponent };